// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sidebar-item-container[data-v-7a1280c0]{padding:0 12px;font-size:14px}.sidebar-item-container a[data-v-7a1280c0]{display:inline-block;width:100%;overflow:hidden;text-decoration:none;vertical-align:top}.sidebar-item-container .nest-menu-container .sidebar-item-container[data-v-7a1280c0]{padding:0}", ""]);
// Exports
module.exports = exports;
